import templateUrl from "emun.salesrep/territory-manager/zipcode/zipcode-prompt.htm";
import ZipcodePromptController from "emun.salesrep/territory-manager/zipcode/zipcode-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const ZipcodePrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'lg quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
		controller: ZipcodePromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default ZipcodePrompt;
